import { translate } from "@locales";
import { interpolatedTextString } from '@models/interactions/interpolate-text';


interface Props {
  search: string;
}


export default function SearchMessage(props: Props) {
  return(
    <div className="flex flex-col gap-4">
      <h2 className=" text-2xl text-base-white font-semibold">{interpolatedTextString("base.no-search-query", props.search)}</h2>
      <p className="text-base-white">{translate("base.no-results-found")}</p>
    </div>
  );
}